import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Box } from '@mui/material';
import DataTable from '../DataTable/DataTable';
import { typeOf } from 'react-is';
import { Settings } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';

const styles = theme => ({
  paperWidth: {
    width: '720px',
  },
  days: {
    marginBottom: theme.spacing(5),
  },
  strong: {
    fontWeight: theme.typography.fontWeightStrong,
  },
  vertical: {
    border: 'none',
    borderLeft: `1px solid ${theme.palette.divider}`,
    height: '100%',
    width: '1px',
  },
});

const ScheduleDialog = ({
  classes, open, onClose, schedule, scaleZero
}) => {
  const columns = [
    {
      name: 'days',
      label: 'Dias',
    },
    {
      name: 'firstShiftIni',
      label: 'Início Turno 1',
    },
    {
      name: 'firstShiftEnd',
      label: 'Término Turno 1',
    },
    {
      name: 'secondShiftIni',
      label: 'Início Turno 2',
    },
    {
      name: 'secondShiftEnd',
      label: 'Término Turno 2',
    },
  ];

  const columnIsZeroScale = [
    {
      name: 'days',
      label: 'Dias',
    },
    {
      name: 'explicitExpectedWorkInMinutes',
      label: 'Horário Máximo por dia',
    }]

  const scheduleNew = schedule.shifts.map(shift => ({ ...shift.shiftsTurns, days: shift.days.join(' ') }));


  let countShift = [];
  const uniqueShifts = scheduleNew.filter((shift, index, array) => {
    const shiftKey = JSON.stringify(shift); // Cria uma chave única para o shift
    const shiftIndex = array.findIndex(s => JSON.stringify(s) === shiftKey);

    if (index == shiftIndex) {
      // É o primeiro índice com a mesma chave, adiciona o shift no array countShift
      countShift.push({ shift: shift, count: 1 });
    } else {
      // Já existe um shift com a mesma chave, incrementa o contador correspondente
      if (countShift[shiftIndex]) {
        countShift[shiftIndex].count++;
      }else{
        countShift.push({ shift: shift, count: countShift[countShift.length -1].count++ })
      }

    }

    return index === shiftIndex;
  });


  const zeroScale = schedule?.shifts[0]?.shiftsTurns?.explicitExpectedWorkInMinutes == null ? false : true

  let content = null;

  if (schedule.workingDay.isRotation) {
    columns.shift();
    content = (
      <React.Fragment>
        <Grid container justify="space-between" className={classes.days}>
          <Grid item xs={3}>
            <Typography color="textSecondary" align="center">
              Categoria de tempo
            </Typography>
            <Typography
              color="textSecondary"
              variant="body1"
              align="center"
              className={classes.strong}
            >
              {schedule.workingDay.category === 'DAYS' ? 'DIAS' : 'HORAS'}
            </Typography>
          </Grid>
          <Grid item xs>
            <hr className={classes.vertical} />
          </Grid>
          <Grid item xs={3}>
            <Typography color="textSecondary" align="center">
              {schedule.workingDay.category === 'DAYS' ? 'Dias' : 'Horas'} de trabalho
            </Typography>
            <Typography
              color="textSecondary"
              variant="body1"
              align="center"
              className={classes.strong}
            >
              {schedule.workingDay.amountWork}
            </Typography>
          </Grid>
          <Grid item xs>
            <hr className={classes.vertical} />
          </Grid>
          <Grid item xs={3}>
            <Typography color="textSecondary" align="center">
              {schedule.workingDay.category === 'DAYS' ? 'Dias' : 'Horas'} de folga
            </Typography>
            <Typography
              color="textSecondary"
              variant="body1"
              align="center"
              className={classes.strong}
            >
              {schedule.workingDay.amountLoose}
            </Typography>
          </Grid>
        </Grid>

        <DataTable rows={[schedule.shifts[0].shiftsTurns]} columns={columns} pagination={false} />
      </React.Fragment>
    );
  } else {
    if (zeroScale == true) {
      for (let unique of uniqueShifts) {
        if(unique.explicitExpectedWorkInMinutes == -1){
          unique.explicitExpectedWorkInMinutes = 0
        }
        const index = uniqueShifts.indexOf(unique);
        const minutos = unique.explicitExpectedWorkInMinutes
        var horas = Math.floor(minutos / 60); // Obtém a parte inteira das horas
        var minutosRestantes = minutos % 60; // Obtém o restante dos minutos
        var stringHoras = horas.toString().padStart(2, '0'); // Garante que a hora tenha dois dígitos
        var stringMinutos = minutosRestantes.toString().padStart(2, '0'); // Garante que os minutos tenham dois dígitos
        let stringResultado = stringHoras + ':' + stringMinutos + ':00';
        unique.explicitExpectedWorkInMinutes = stringResultado
        if (countShift[index].count == 1) {
          unique.days = unique.days.split(' ').pop()
        }
        unique.days = unique.days.split(' ').slice(0, countShift[index].count).join(' ');
      }
    }
    content = (
      <DataTable
        rows={uniqueShifts}
        columns={zeroScale == true ? columnIsZeroScale : columns}
        pagination={false}
      />
    );
  }


  const data = [
    { label: 'Tolerância na intrajornada', value: schedule.shifts[0] ? schedule.shifts[0].shiftsTurns.isToConsiderClockInDelay : null },
    { label: 'Conversão da hora noturna', value: schedule.workingDay.considerNightHoursCorrectedInBankHour },
    { label: 'Limite de horas excedentes', value: schedule.workingDay.hasBankHourLimit },
    { label: 'Considerar hora extra especial aos domingos e feriados', value: schedule.workingDay.specialHoursSundayAndHoliday },
    { label: 'Atraso máximo permitido do dia', value: schedule.workingDay.maxAccumulatedPositiveTolerance },
    { label: 'Crédito máximo no banco de horas', value: schedule.workingDay.maxCreditToBankOfHours },
    { label: 'Horas extras especiais após horario definido', value: schedule.workingDay.specialHoursAfterMinutes }
  ];

  const [openModal, setOpenModal] = useState(false)
  const handleClose = () => {
    setOpenModal(false)
  }
  const dt = []

  for (let dado of data) {
    if (typeof dado.value === 'boolean') {
      const d = dado.value == true ? 'Sim' : 'Não'
      const label = dado.label
      dt.push({ label: label, value: d })
    } else if (typeof dado.value === 'number' && Number.isInteger(dado.value)) {
      var minutos = dado.value == null ? 0 : dado.value
      var horas = Math.floor(minutos / 60); // Obtém a parte inteira das horas
      var minutosRestantes = minutos % 60; // Obtém o restante dos minutos
      // Cria a string no formato "HH:MM"
      var stringHoras = horas.toString().padStart(2, '0'); // Garante que a hora tenha dois dígitos
      var stringMinutos = minutosRestantes.toString().padStart(2, '0'); // Garante que os minutos tenham dois dígitos
      var string = stringHoras + ':' + stringMinutos;
      const label = dado.label
      dt.push({ label: label, value: string })
    } else {
      dt.push({ label: dado.label, value: dado.value })
    }
  }
  const userIdSuporte = JSON.parse(localStorage.getItem('companies'))[0].userId

  const suportSchudeleConfig = userIdSuporte == 33920 || userIdSuporte == 2005 || userIdSuporte == 35802 || userIdSuporte == 50639 || userIdSuporte == 53230 || userIdSuporte == 58886 || userIdSuporte == 74697 || userIdSuporte == 77251;


  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{ classes: { root: classes.paperWidth } }}
    >
      <DialogTitle>{zeroScale == false ? schedule.workingDay.description : schedule.workingDay.description + ' - Escala Flexível'}</DialogTitle>
      {zeroScale === false && suportSchudeleConfig && (
        <IconButton onClick={() => setOpenModal(true)} style={{ justifyContent: 'flex-start' }}>
          <Settings />
          <Typography variant="button">Configurações de escala</Typography>
        </IconButton>
      )}

      <Dialog open={openModal} onClose={handleClose}>
        <DialogTitle>Configurações</DialogTitle>
        <DialogContent>
          {dt.map((item, index) => (
            <Grid item key={index}>
              <Typography variant="body1" color="textSecondary">
                <span style={{ fontWeight: 'bold', marginRight: '5px' }}>{item.label}:</span>
                <span style={{ fontWeight: 'normal' }}>{item.value}</span>
              </Typography>
              {index !== dt.length - 1 && <hr style={{ margin: '5px 0' }} />}
            </Grid>
          ))}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      <DialogContent>{content}</DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary" autoFocus>
          FECHAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ScheduleDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  schedule: PropTypes.shape({
    workingDay: PropTypes.shape({
      description: PropTypes.string.isRequired,
      isRotation: PropTypes.bool.isRequired,
      category: PropTypes.oneOf(['DAYS', 'HOURS']),
      amountWork: PropTypes.number,
      amountLoose: PropTypes.number,
    }).isRequired,
    shifts: PropTypes.arrayOf(PropTypes.shape({
      days: PropTypes.array.isRequired,
      shiftsTurns: PropTypes.object.isRequired,
    })).isRequired,
  }).isRequired,
};

export default withStyles(styles)(ScheduleDialog);
